import React, { useState } from 'react';
import { AppInstallerContent } from './AppInstallerContent';
import '@wix/design-system/styles.global.css';
import { InstallerRenderControlProvider } from './context/InstallerRenderControlContext';
export const AppInstaller = props => {
  const [retryInstallationCount, setRetryInstallationCount] = useState(0);
  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: retryInstallationCount
  }, /*#__PURE__*/React.createElement(InstallerRenderControlProvider, {
    panoramaClient: props.panoramaClient,
    appId: props.appId,
    retryInstallationCount: retryInstallationCount,
    setRetryInstallationCount: setRetryInstallationCount,
    essentials: props.essentials,
    topology: props.topology,
    onUiInitialLoad: props.onUiInitialLoad
  }, /*#__PURE__*/React.createElement(AppInstallerContent, props)));
};
//# sourceMappingURL=AppInstaller.js.map